import { ShoppingBag } from "lucide-react";
import { useResource } from "@/admin/useResource";
import {
  PageHeader,
  ResourceView,
  StatusBadge,
  money,
  fmtDate,
} from "@/admin/adminComponents";

const STATUS_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "preparing", label: "Preparing" },
  { value: "out_for_delivery", label: "Out for Delivery" },
  { value: "delivered", label: "Delivered" },
  { value: "cancelled", label: "Cancelled" },
];

const columns = [
  { key: "id", label: "Order ID", render: (r) => <span className="font-mono text-xs text-halalgo-ink">{r.id}</span> },
  { key: "customer_name", label: "Customer" },
  { key: "restaurant_name", label: "Restaurant" },
  { key: "rider_name", label: "Rider" },
  { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
  { key: "total", label: "Total", render: (r) => <span className="font-semibold">{money(r.total, r.currency)}</span> },
  { key: "created_at", label: "Placed", render: (r) => <span className="whitespace-nowrap text-xs">{fmtDate(r.created_at)}</span> },
];

export default function Orders() {
  const { data, mocked, loading, refreshing, reload } = useResource("/orders", "orders");
  return (
    <div data-testid="admin-orders-page">
      <PageHeader title="Orders" subtitle="Live order flow across all partner kitchens." mocked={mocked} />
      <ResourceView
        columns={columns}
        rows={data}
        loading={loading}
        testId="orders-table"
        exportName="orders"
        onRefresh={reload}
        refreshing={refreshing}
        searchPlaceholder="Search by order, customer, restaurant..."
        searchKeys={["id", "customer_name", "restaurant_name", "rider_name"]}
        filter={{ key: "status", placeholder: "Filter by status", allLabel: "All statuses", options: STATUS_OPTIONS }}
        dateFilter={{ key: "created_at", label: "Order date" }}
        detailTitle={(r) => `Order ${r.id}`}
        detailSubtitle={(r) => `${r.customer_name} \u2022 ${r.restaurant_name}`}
      />
    </div>
  );
}
